<template>
  <div class="task-box poster-main" v-if="bodyShow">
    <div v-for="(item,index) in poster.components" :key="index">
      <!-- 文本 -->
      <van-cell-group v-if="item.type=='text'" class="grouping pj2-task">
        <van-field placeholder="请填写姓名" @input="inputVaild()"  v-model="form[item.name]" label="姓名" />
      </van-cell-group>
      <!-- 图片 -->
      <div class="pj-task-group"  v-if="item.type=='image'">
        <h3>{{item.config.label}}</h3>
        <div class="upload-img">
          <a href="javascript:;" v-if="uploadImgBool" @click="uploadImgHandle(item.name)">
            <img class="pg-img" :src="form[item.name]?form[item.name]:imgSrc" />
          </a>
          <a href="javascript:;" v-else >
            <van-uploader  name="uploader"   :after-read="onRead(item.name)">
              <img class="pg-img" :src="form[item.name]?form[item.name]:imgSrc" />
            </van-uploader>
          </a>
          <p>{{item.config.tips}}<span v-if="item.name=='qrcode'" class="sl" @click='qrcodeShow=true'>示例</span></p>
        </div>
      </div>
      <!-- 提交 -->
    </div>
    <div class="submitBtn">
      <van-button v-if="validationHandle()" @click="submitHandle" class="actice">生成海报</van-button>
      <van-button v-else>生成海报</van-button>
    </div>
    <!-- 海报弹窗 -->
    <van-popup class="pre-popo" v-model="preShow">
      <img :src="preImgLink" />
      <p>长按上方图片保存到相册</p>
    </van-popup>
     <!-- 示例二维码弹窗 -->
    <van-popup class="pre-qrcode" v-model="qrcodeShow">
      <img src="@a/yqm_.png" />
    </van-popup>
  </div>
</template>
<script>
import { isWeixin } from "@/utils/tools"
import { get_poster_config,create_poster,upload_image_file,upload_wx_image } from "@/api/course"
import { shareCon } from "@/utils/wxconfig";
import wx from "weixin-js-sdk"
let imgSrc = require('../../../assets/upload_img.png');

export default {
  data() {
      return {
        bodyShow: false,
        poster:{},
        form:{},
        // 上传图片类型
        uploadImgBool:true,
        image_url:'',
        serverId:'',
        imgSrc:imgSrc,
        uploadImgBool:true,
        preShow:false,
        preImgLink:'',
        qrcodeShow:false
      }
    },
    methods: {
      // 上传图片
      uploadImgHandle(name) {
        wx.chooseImage({
          count: 1,
          sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: (res) => {
            // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            wx.uploadImage({
              localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: (res2) => {
                this.serverId = res2.serverId;
                this.imgSave(name);
              }
            });
          }
        });

      },
      imgSave(name) {

        upload_wx_image({
          server_id:this.serverId,
        }).then(res => {
          this.$forceUpdate()
          this.form[name] = res.image_url;
        });
      },

      // 提交数据
      submitHandle() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        this.form['id'] = this.$route.query.id;
        create_poster(this.form).then(data => {
          this.$toast.clear();
          if (data.code ==10002) {
            this.$toast(data.msg);
            return
          }
          this.preImgLink = data.image_url;
          this.preShow = true;

          });

      },
      inputVaild(){
        this.$forceUpdate();
        this.validationHandle();
      },
      // 验证
      validationHandle() {
        let str_fields = Object.keys(this.form)?Object.keys(this.form):[];
        if(str_fields.length==0){
          return false;
        }
        // 循环判断数组内属性内容是为空
        for (let i = 0; i < str_fields.length; i++) {
          if (this.$Validator.isEmpty(this.form[str_fields[i]])) {
            return false;
          }
        }
        return true;
      },
      // 上传图片判断
      onRead(name){
        return files => {
          // FormData 对象
          let form = new FormData();
          // 文件对象
          form.append("image", files.file);
    
          // 上传图片接口
          upload_image_file(form).then((res) => {
            if (res.code ==10002) {
              this.$toast(res.msg);
              return
            }
            this.$forceUpdate()
            this.form[name] = res.image_url;
            
          });
        }

        
      },
      pullData() {
        let q = this.$route.query;
        get_poster_config({
          id: q.id
        }).then((data) => {
          if(data.code==10002){
            this.$toast(data.data.msg);
            return;
          }
          if(!isWeixin()){
            this.uploadImgBool = false;
          }
          this.poster = data.poster;
          document.title = data.poster.name;
          if(data.poster.components && data.poster.components.length>0){
            // 循环判断数组内属性内容是为空
            for (let i = 0; i < data.poster.components.length; i++) {
              this.form[data.poster.components[i].name]='';
            }
          }
          
          this.bodyShow = true;
        })
      }
    },
    created(){
        this.pullData();
        shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/taskStyle.scss";
.poster-main {
  padding: 120px 30px 40px;
  position: absolute;
  width: 100%;
  max-width: 750px;
  left: 50%;
  top: 0;
  background-color: #ffffff;
  transform: translateX(-50%);
  height: 100%;
  overflow: auto;
  
  .pg-img{
    border: 2px solid #d8d8d8;
  }
  .pj-task-group{
    margin-top: 80px;
    position: relative;
  }
  .submitBtn button{
    width:220px;
    display:block;
  }
  .pre-popo{
    background: transparent;
    img{
      width:650px;
    }
    p{
      font-size:26px;
      color:#ffffff;
      text-align:center;
      margin-top:30px;
    }
  }
  span.sl{
    color:#35a9ec;
    font-weight:bold;
    margin-left:18px;
  }
  .van-hairline--top-bottom::after{
    border: 0;
  }
}
</style>
<style lang="scss">
.poster-main .grouping .van-cell .van-cell__value input{
  -webkit-appearance: none;
}
</style>